import pages from '@/app/drilling/pages.js'
import roles from '@/app/drilling/roles.js'

const drillingPages = new pages();

export default [
  {
    path: '/drilling/dashboard',
    name: 'drilling-reports-dashboard',
    component: () => import('@/app/geo/gradecontrol/reports/report.vue'),
    props: {
      groupId: 'drillingGroupId',
      reportId: 'drillingDashboard'
    },
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'Drilling', url: '/drilling', i18n: 'Drilling.MainTitle' },
        { title: 'Dashboard', active: true, i18n: 'Drilling.Reports.Dashboard' }
      ],
      requireAuth: true,
      requireRoles: roles.readers,
      pageTitle: 'Dashboard',
      i18n: 'Drilling.Reports.Dashboard',
      rule: 'editor'
    }
  },
  {
    path: '/drilling/optimizedReport',
    name: 'drilling-reports-optimized',
    component: () => import('@/app/geo/gradecontrol/reports/report.vue'),
    props: {
      groupId: 'drillingGroupId',
      reportId: 'drillingOptimized'
    },
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'Drilling', url: '/drilling', i18n: 'Drilling.MainTitle' },
        { title: 'Optimized', active: true, i18n: 'Drilling.Reports.Optimized' }
      ],
      requireAuth: true,
      requireRoles: roles.readers,
      pageTitle: 'Optimized',
      i18n: 'Drilling.Reports.Optimized',
      rule: 'editor'
    }
  },
  {
    path: '/drilling/drillingAnalytics',
    name: 'drilling-reports-analytics',
    component: () => import('@/app/geo/gradecontrol/reports/report.vue'),
    props: {
      groupId: 'drillingGroupId',
      reportId: 'drillingAnalytics',
      forceProject: true
    },
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'Drilling', url: '/drilling', i18n: 'Drilling.MainTitle' },
        { title: 'Analytics', active: true, i18n: 'Drilling.Reports.Analytics' }
      ],
      requireAuth: true,
      requireRoles: roles.readers,
      pageTitle: 'Driling Analytics',
      i18n: 'Drilling.Reports.Optimized',
      rule: 'editor'
    }
  },
  ...drillingPages.getRoutes()
]
